<template>
  <div class='row page-section small-collapse'>
    <div class='large-12 columns'>
      <div v-if='hasData' class='block block-live-wrapper' :class='{"margin-bottom": !showError}'>
        <h3 class='live-list-header'>{{title}}</h3>
        <div class='block block-live-small'>
          <button v-if='showBackButton' v-on:click='backButtonClicked' class='live-list-small-nav live-list-small-nav-prev' :class='{"live-list-small-nav-next": isNext}'><span class='visuallyhidden'>{{textShowFirst}}</span></button>
          <slider-content></slider-content> 
          <div class='live-list-padding'>
            <div class='live-list-small-scrollbar' :class='{hidden: !showScrollbar}' data-live-list-small-scrollbar>
              <div class='handle'>
                <div class='mousearea'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if='showError' class='alert-wrapper' :class='{"air-top": hasData && showError}'>
        <div class="alert-hearings">
          <h3 class='h2'>{{errorTitle}}</h3>
          <p v-html='errorText'></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Comment out requires in production
// require('jquery')
// require('../../../../../public/js/vendor/jquery.easing-1.3.min.js')
// require('../../../../../public/js/vendor/sly.min.js')

import mixins from '../../mixins'
import lang from '../../lang'
import SliderContent from './SliderContent'

export default {
  mixins: [mixins],
  name: 'slider',
  data () {
    return {
      title: this.$root.cmsData.mainBlock.videoBarTitle,
      errorTitle: this.$root.cmsData.mainBlock.hearingsUnavailableTitle,
      errorText: this.$root.cmsData.mainBlock.hearingsUnavailableMessage,
      textShowFirst: lang.showFirst[this.$root.cmsData.lang],
      numberOfFinished: this.liveHelper().numberOfFinished(this.$root.cmsData, this.$root.liveData),
      sly: undefined,
      resizeEventAdded: false,
      isNext: false,
      hasUpdatedOnce: false,
      hasData: !this.$root.errorNoData,
      showError: this.$root.cmsData.mainBlock.hearingErrorBottom
    }
  },
  components: {
    SliderContent
  },
  mounted () {
    this.setupSlider()
  },
  updated () {
    if (!this.hasUpdatedOnce) this.setupSlider()
  },
  computed: {
    showBackButton: function () {
      if (!this.sly) return false
      if (!this.sly.initialized) return false
      if (this.sly.pos.start === this.sly.pos.end) {
        return false
      }
      if (this.numberOfFinished > 0 && this.numberOfFinished < this.sly.items.length) {
        return true
      }
    },
    showScrollbar: function () {
      if (!this.sly) return false
      if (!this.sly.initialized) return false
      return this.sly.pos.start !== this.sly.pos.end
    }
  },
  methods: {
    backButtonClicked: function (e) {
      e.preventDefault()
      if (this.isNext) this.sly.toStart(this.numberOfFinished)
      else this.sly.toStart()
    },
    setupSlider: function () {
      var frame = document.querySelector('[data-live-list-small-wrapper]')
      var scrollbar = document.querySelector('[data-live-list-small-scrollbar]')
      let options = {
        horizontal: 1,
        itemNav: 'basic',
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        easing: 'easeOutExpo',
        scrollBar: scrollbar,
        scrollBy: 1,
        speed: 300,
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1
      }
      if (this.sly) {
        this.sly.destroy()
        this.hasUpdatedOnce = true
      }
      this.sly = new window.Sly(frame, options).init()

      if (this.numberOfFinished > 0 && this.numberOfFinished < this.sly.items.length) {
        this.sly.toStart(this.numberOfFinished)
      }

      this.sly.on('moveEnd', function () {
        if (this.numberOfFinished > 0 && this.numberOfFinished < this.sly.items.length) {
          this.isNext = this.sly.pos.cur === this.sly.pos.start
        }
      }.bind(this))

      if (!this.resizeEventAdded) {
        window.addEventListener('resize', function (e) {
          this.sly.reload()
        }.bind(this))
        this.resizeEventAdded = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Slider.vue?6e8b2054